<template>
    <!-- <v-dialog v-model="show" :width="$vuetify.breakpoint.lgAndUp ? '50%' : '90%'" max-width="760" scrollable> -->
    <v-dialog v-model="show" max-width="760" scrollable>
        <v-card v-if="giftcard && show" class="v-card--dialog">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">상품문의</h3>
                <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body">
                <v-row>
                    <v-col cols="12" md="4">
                        <div class="border">
                            <v-img :src="`https://daehanbooksgiftcard.com` + giftcard.thumb" max-width="100%" :aspect-ratio="1/1" contain />
                        </div>
                    </v-col>
                    <v-col cols="12" md="8">
                        <div class="tit-wrap mb-20px mb-md-30px">
                            <h2 class="tit tit--sm primary--text">{{ giftcard.name }}</h2>
                        </div>
                        <div class="font-size-14">
                            <v-row align="center" class="row--small">
                                <v-col cols="3">수량</v-col>
                                <v-col cols="9">
                                    <div>
                                        <p class="font-size-12 font-size-md-14 primary--text mt-6px">{{quantityText}}</p> 
                                        <v-select v-if="giftcard.mode == 'mobile'" v-model="order.quantity" outlined hide-details :items="limits"/>
                                        <v-text-field v-else v-model="order.quantity" outlined :rules="quantityRules"/>
                                        <!-- <p class="font-size-12 font-size-md-14 primary--text mt-6px">(남은 재고 수량 : {{ giftcard.stock }}개)</p>  -->
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row align="center" class="row--small">
                                <v-col cols="3">보유캐시</v-col>
                                <v-col cols="9">
                                    <p class="font-weight-medium"><b class="font-size-16 font-size-md-20">{{ me?.cash?.format?.() }}</b> 캐시</p>
                                </v-col>
                            </v-row>
                            <v-row align="center" class="row--small">
                                <v-col cols="3">사용캐시</v-col>
                                <v-col cols="9">
                                    <div>
                                        <div class="font-weight-medium"><b class="font-size-16 font-size-md-20">{{ parseInt((giftcard.faceamt * giftcard[me.riskManagement.giftcard.level + "Commission"] / 100 + giftcard.faceamt) * order.quantity).format()}}</b> 캐시</div>
                                        <p class="font-size-12 font-size-md-14 primary--text mt-6px">(해당 상품은 구매 금액의 {{ giftcard[me.riskManagement.giftcard.level + "Commission"] }}% 수수료가 부과됩니다.)</p>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row v-if="giftcard.mode == 'mobile' && !$vuetify.breakpoint.mobile" align="center" class="row--small">
                                <v-col cols="3">발송전화번호</v-col>

                                <v-col cols="9">
                                    <v-row align="center" class="row--small">
                                        <v-col>
                                            <v-select v-model="defaultItem.receiver.phone1" outlined hide-details :items="phones" />
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <v-text-field v-model="defaultItem.receiver.phone2" outlined hide-details maxlength="4"/>
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <v-text-field v-model="defaultItem.receiver.phone3" outlined hide-details maxlength="4" ref="phone3"/>
                                        </v-col>
                                        <v-col cols="auto"><v-icon @click="phoneReset">mdi-close</v-icon></v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row v-if="giftcard.mode == 'mobile' && $vuetify.breakpoint.mobile" align="center" class="row--small">
                                <v-col cols="3">발송<br/>전화번호</v-col>
                                <v-col cols="9">
                                    <v-text-field v-model="order.receiver.phone" outlined hide-details clearable maxlength="13"/>
                                </v-col>
                            </v-row>
                            <v-row v-if="giftcard.mode == 'paper'" align="center" class="row--small">
                                <v-col cols="3">받는분</v-col>
                                <v-col cols="9">
                                    <v-text-field v-model="order.receiver.name" outlined hide-details />
                                </v-col>
                            </v-row>
                            <v-row v-if="giftcard.mode == 'paper'" align="center" class="row--small">
                                <v-col cols="3">전화번호</v-col>
                                <v-col cols="9">
                                    <v-text-field v-model="order.receiver.phone" outlined hide-details @input="order.receiver.phone = order.receiver.phone.replace(/[^0-9]/g, '')" />
                                </v-col>
                            </v-row>
                            <v-row v-if="giftcard.mode == 'paper'" align="center" class="row--small">
                                <v-col cols="3">이메일</v-col>
                                <v-col cols="9">
                                    <v-text-field v-model="order.receiver.email" outlined hide-details />
                                </v-col>
                            </v-row>
                            <v-row v-if="giftcard.mode == 'paper'" align="center" class="row--small">
                                <v-col cols="3">우편번호</v-col>
                                <v-col>
                                    <v-text-field v-model="order.shippingAddress.postcode" outlined hide-details />
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn color="primary" class="pa-3 ml-1" height="38" min-width="auto" @click="$refs.daumPostcode.open()"><v-icon>mdi-magnify</v-icon></v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-if="giftcard.mode == 'paper'" align="center" class="row--small">
                                <v-col cols="3">주소</v-col>
                                <v-col cols="9">
                                    <v-text-field v-model="order.shippingAddress.address1" outlined hide-details />
                                </v-col>
                            </v-row>
                            <v-row v-if="giftcard.mode == 'paper'" align="center" class="row--small">
                                <v-col cols="3">상세주소</v-col>
                                <v-col cols="9">
                                    <v-text-field v-model="order.shippingAddress.address2" outlined hide-details />
                                </v-col>
                            </v-row>
                            <!-- <v-row align="center" class="row--small">
                                <v-col cols="3">상세주소</v-col>
                                <v-col cols="9">
                                    <v-text-field v-model="order.shippingAddress.address2" outlined hide-details />
                                </v-col>
                            </v-row> -->
                            <div class="mt-16px">
                                <v-row class="row--x-small">
                                    <v-col cols="12" md="6">
                                        <v-btn large block arge color="primary" @click="pay">결제하기</v-btn>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-btn large block arge color="grey" @click="close">취소</v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <div class="mt-30px">
                    <div class="grey lighten-4 pa-12px">
                        <p v-html="giftcard.content?.replace?.(/\n/g, '<br>')" class="font-size-14 font-size-md-16"></p>
                    </div>
                </div>
            </div>
        </v-card>
        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { order.shippingAddress.postcode = postcode; order.shippingAddress.address1 = address; }" />
    </v-dialog>
</template>
<script>
import api from "@/api";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import { mdiClose } from '@mdi/js';
export default {
    components: {
        DaumPostcode
    },
    data(){
        return {
            mdiClose,

            show: false,
            giftcard: null,
            me: null,

            phones: ["010", "011", "016", "017", "019"],
            order: null,
            defaultItem: {
                _giftcard: null,
                mode: null,
                quantity: 1,

                receiver: {
                    name: '',
                    phone: '',
                    phone1: '',
                    phone2: '',
                    phone3: '',
                    email: '',
                },

                shippingAddress: {
                    postcode: '',
                    address1: '',
                    address2: ''
                },
            },

            limits: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        }
    },
    computed: {
        scope(){ return this.$store.state.scope },
        quantityText() {
            const { giftcard } = this;
            let text = `(남은 재고 수량 : ${giftcard.stock}개`;
            if (giftcard.mode === 'paper') text += ` / 최소 구매 수량 : ${giftcard.minimumPurchase || 1}개`;
            text += ')';

            return text;
        },
        quantityRules() {
            const { giftcard: { mode, minimumPurchase, stock } } = this;
            const minimumQuantity = mode === 'paper' ? (minimumPurchase || 1) : 1;

            return [
                value => value >= minimumQuantity || `최소 ${minimumQuantity}개부터 구매 가능합니다.`,
                value => value <= 1000 || '최대 1000개까지 구매 가능합니다.',
                value => value <= stock || '재고 수량이 부족합니다.'
            ];
        },
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            this.me  = me
        },

        validate(){
            try{
                switch(this.giftcard.mode){
                    case "mobile": {
                        if(!this.order.receiver.phone.match(/^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/)) throw new Error("휴대폰번호를 올바른 형태로 입력해주세요");
                        break;
                    }
                    case "paper": {
                        const { order, giftcard: { minimumPurchase } } = this;
                        if(!((minimumPurchase || 1) <= order.quantity && order.quantity <= 1000 )) throw new Error(`최소 ${minimumPurchase || 1}개부터 1000개까지 구매가능합니다.`)
                        if(!order.receiver.name) throw new Error("받는사람 이름을 입력해주세요");
                        if(!order.receiver.phone) throw new Error("받는사람 연락처를 입력해주세요");
                        if(!order.receiver.phone.match(/^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/)) throw new Error("휴대폰번호를 올바른 형태로 입력해주세요");
                        if(!order.receiver.email) throw new Error("받는사람 이메일을 입력해주세요");
                        if(!order.shippingAddress.postcode || !order.shippingAddress.address1 || !order.shippingAddress.address2) throw new Error("받는사람 주소를 입력해주세요");
                        break;
                    }
                }

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async pay(){
            try{
                let confirmMessage = `'${this.order.receiver.phone.phoneNumberFormat()}' 입력하신 전화번호를 확인 바랍니다.\n교환하시겠습니까?`;
                if (this.giftcard.sendMethod === "FMS" || this.giftcard.platform === "topping" || this.giftcard.platform === "soil") {
                    confirmMessage = "★카카오톡 친구 미추가 시 해당 상품을 받아보실 수 없습니다.★\n\n" + confirmMessage
                }
                
                if(this.validate() && confirm(confirmMessage)){
                    if(!this.me.ci){
                        alert("구매 권한이 없습니다.\n[로그인 > 마이페이지 > 회원정보수정 > 본인인증받기] 등록 후 이용해주세요.")
                        this.$router.push('/mypage/profile')
                        return;
                    }

                    await api.v1.gshop.orders.post(this.order);

                    let { me } = await api.v1.me.profile.get();
                    this.me = me;

                    let { giftcard } = await api.v1.gshop.giftcards.get(this.giftcard);
                    this.giftcard = giftcard;

                    alert("상품권 주문이 완료되었습니다");
                    this.close();
                }
            } catch(error) {
                console.error(error);
            };
        },
        async open(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;

            let { giftcard } = await api.v1.gshop.giftcards.get(this.giftcard);
            this.giftcard = giftcard;

            this.order = JSON.parse(JSON.stringify(this.defaultItem));
            this.order.mode = giftcard.mode;
            this.order._giftcard = giftcard._id;

            let [phone1, phone2, phone3] = this.me.phone?.phoneNumberFormat?.()?.split?.('-') || [];
            this.defaultItem.receiver.phone1 = phone1
            this.defaultItem.receiver.phone2 = phone2
            this.defaultItem.receiver.phone3 = phone3
            this.order.receiver.phone = this.me.phone
            this.show = true;

            if(this.giftcard.mode === "paper") this.order.quantity = this.giftcard.minimumPurchase || 1;            
        },
        close(){
            this.show = false;
        },
        phoneReset() {
            this.defaultItem.receiver.phone1 = '010',
            this.defaultItem.receiver.phone2 = null,
            this.defaultItem.receiver.phone3 = null
        }
    },
    watch: {
        "defaultItem.receiver": {
            deep: true,
            handler(value){
                var { phone1, phone2, phone3 } = value;
                this.order.receiver.phone = (phone1 && phone2 && phone3) ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;
            }
        },
        "order.receiver.phone"() {
            if(this.order.receiver.phone.length === 3 || this.order.receiver.phone.length === 8){
                this.order.receiver.phone = this.order.receiver.phone + "-"
            }
        },
        "defaultItem.receiver.phone2"() {
            if(this.defaultItem.receiver.phone2.length === 4) this.$refs.phone3.focus()
        }
    }
}
</script>

<style scoped>
.modal-phones--wrap {
    display:flex;
}
.modal-phones--wrap > div {
    width: 33.33%;
}
.modal-phones--wrap > div.phones-close {
    width: 10%;
}
</style>